import { GetInsurancePricingParams, CreateInsurancePricingParams, UpdateInsurancePricingParams } from '../../interfaces/InsurancePricing';
import { APICore, INSURANCE_URL } from './apiCore';

const api = new APICore();

const getInsurancePricings = (params?: GetInsurancePricingParams) => {
    const url = `${INSURANCE_URL}/insurance-pricing`;
    return api.get(url, params);
};

const createInsurancePricing = (params: CreateInsurancePricingParams) => {
    return api.create(`${INSURANCE_URL}/insurance-pricing`, params);
};

const updateInsurancePricing = (pricingId: string, params: UpdateInsurancePricingParams) => {
    const relativeUrl = `/insurance-pricing/${pricingId}`;
    return api.update(`${INSURANCE_URL}${relativeUrl}`, params);
};

const deleteInsurancePricing = (pricingId: string) => {
    const relativeUrl = `/insurance-pricing/${pricingId}`;
    return api.delete(`${INSURANCE_URL}${relativeUrl}`);
};

const getCoverageTypes = (params?: { branch?: string; company?: string }) => {
    return api.get(`${INSURANCE_URL}/insurance-pricing/coverage-types`, params);
};

export { getInsurancePricings, createInsurancePricing, updateInsurancePricing, deleteInsurancePricing, getCoverageTypes };
